import styled, { css } from 'styled-components';
import color from '../../../config/colors.json';

const textStyle = css`
    font-family: 'Poppins', sans-serif;
    color: ${color.darkgrey2};  
`;

export const Container = styled.div`
    width: 1222px;
    @media only screen and (max-width: 1000px) {
            width: 900px;
    }
    @media only screen and (max-width: 650px) {
            width: 600px;
    }
    overflow: hidden;
    box-shadow: 0px 3px 6px #00000029;
`;

export const Title = styled.span`
    ${textStyle};
    font-size: 20px;
    line-height: 30px;
`;

export const Label = styled.span`
    ${textStyle};
    font-size: 19px;
    line-height: 29px;
`;

const height = '7px';
const thumbHeight = 20;

const thumbColor = '#ddd';
const thumbHoverColor = '#ccc';

export const Range = styled.input`
    width: 100%;
    overflow: hidden;
  display: block;
  appearance: none;
  max-width: 700px;
  width: 100%;
  margin: 0;
  cursor: pointer;
  height: 25px;

  &:focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: ${height};
    border-radius: 50px;
    background: ${color.darkGrey2};
  }

  &::-webkit-slider-thumb {
    position: relative;
    appearance: none;
    height: ${thumbHeight}px;
    width: ${thumbHeight}px;
    background: ${thumbColor};
    border-radius: 100%;
    border: 0;
    top: 50%;
    transform: translateY(-50%);
    transition: background-color 150ms;
  }

  &::-moz-range-track,
  &::-moz-range-progress {
    width: 100%;
    height: ${height};
    background: ${color.darkGrey2};
  }

  &::-moz-range-progress {
    background: ${color.darkGrey2};
  }

  &::-moz-range-thumb {
    appearance: none;
    margin: 0;
    height: ${thumbHeight};
    width: ${thumbHeight};
    background: ${thumbColor};
    border-radius: 100%;
    border: 0;
    transition: background-color 150ms;
  }

  &::-ms-track {
    width: 100%;
    height: ${height};
    border: 0;
    /* color needed to hide track marks */
    color: transparent;
    background: transparent;
  }

  &::-ms-fill-lower {
    background: ${color.darkGrey2};
  }

  &::-ms-fill-upper {
    background: ${color.darkGrey2};
  }

  &::-ms-thumb {
    appearance: none;
    height: ${thumbHeight};
    width: ${thumbHeight};
    background: ${thumbColor};
    border-radius: 100%;
    border: 0;
    transition: background-color 150ms;
    /* IE Edge thinks it can support -webkit prefixes */
    top: 0;
    margin: 0;
    box-shadow: none;
  }

  &:hover,
  &:focus {
    &::-webkit-slider-thumb {
      background-color: ${thumbHoverColor};
    }
    &::-moz-range-thumb {
      background-color: ${thumbHoverColor};
    }
    &::-ms-thumb {
      background-color: ${thumbHoverColor};
    }
  }

`;
